/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.util

import dev.jordond.connectivity.Connectivity
import dev.jordond.connectivity.ConnectivityProvider
import kotlinx.browser.window
import kotlinx.coroutines.channels.awaitClose
import kotlinx.coroutines.flow.callbackFlow

actual val connectivityProvider: Connectivity
    get() = Connectivity(
        provider = ConnectivityProvider(
            callbackFlow {
                trySend(window.navigator.onLine.toStatus())

                val onOnline: (org.w3c.dom.events.Event) -> Unit = {
                    trySend(Connectivity.Status.Connected(metered = false))
                }
                val onOffline: (org.w3c.dom.events.Event) -> Unit = {
                    trySend(Connectivity.Status.Disconnected)
                }

                window.addEventListener("online", onOnline)
                window.addEventListener("offline", onOffline)

                awaitClose {
                    window.removeEventListener("online", onOnline)
                    window.removeEventListener("offline", onOffline)
                }
            },
        ),
    ) {
        autoStart = true
    }

private fun Boolean.toStatus(): Connectivity.Status =
    if (this) Connectivity.Status.Connected(metered = false) else Connectivity.Status.Disconnected
